<template>
    <div ref="container" class="loader">

    </div>
</template>


<script>

// Libs
import gsap from 'gsap'

// Helpers
import MyEmitter from '../../helpers/MyEmitter'

// Utils
import params from '../../utils/params'

export default {
    name: "LayoutLoader",
    mounted: function(){
        
        MyEmitter.on(params.Events.onLoaderEnd, () => {  
            gsap.to(this.$refs.container, {
                duration: .2,
                onComplete: () => {
                    this.$refs.container.style.display = "none"
                },

                opacity: 0
            })
        })
    }
}
</script>


<style lang="scss">
    .loader{
        @include fixed-fullscreen();
        z-index: 20;
        background-color: $black;
    }
</style>